import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "moon"
const MoonIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M12.25 21a8.9 8.9 0 0 1-3.606-.734 9.4 9.4 0 0 1-2.93-1.983 9.4 9.4 0 0 1-1.981-2.935A9 9 0 0 1 3 11.736q0-2.935 1.649-5.32t4.419-3.348a.96.96 0 0 1 .939.126q.435.31.412.837a9.2 9.2 0 0 0 .618 3.715 9.05 9.05 0 0 0 2.06 3.142 9 9 0 0 0 3.138 2.063 9.2 9.2 0 0 0 3.709.62q.595-.023.882.4.286.425.102.952-1.007 2.752-3.377 4.414Q15.181 21 12.251 21" />
        </svg>
      }
    </span>
  )
}
export default MoonIcon
